import {Datum, Uhrzeit} from "./types";

/**
 * Daten eines Termins.
 *
 * @author Andreas Wenger <andi@xenoage.com>
 */
export class Termin {

  beschreibung: string;
  datum: Datum;
  uhrzeit: Uhrzeit;

}



// WEBPACK FOOTER //
// ./src/model/termin.ts